<template lang="pug">
  div.d-flex.justify-space-between
    template(v-for="stamp in totalStamp")
      template(v-if="stamp <= stampCollected")
        loyalty-stamp-gift(v-if="isRewardIcon(stamp)" success :padding-top="giftIconPaddingVertical" :padding-bottom="giftIconPaddingVertical")
        loyalty-stamp-success(v-else :padding-top="successIconPaddingVertical" :padding-bottom="successIconPaddingVertical")
      template(v-else)
        loyalty-stamp-gift(v-if="isRewardIcon(stamp)" :padding-top="giftIconPaddingVertical" :padding-bottom="giftIconPaddingVertical")
        loyalty-stamp-number(v-else :stamp-number="stamp" :padding-top="numberIconPaddingVertical" :padding-bottom="numberIconPaddingVertical")
</template>

<script>
import LoyaltyStampSuccess from "@/components/clinic/checkout/marketing/LoyaltyStampSuccess.vue";
import LoyaltyStampNumber from "@/components/clinic/checkout/marketing/LoyaltyStampNumber.vue";
import LoyaltyStampGift from "@/components/clinic/checkout/marketing/LoyaltyStampGift.vue";

export default {
  components: {
    LoyaltyStampGift, LoyaltyStampNumber, LoyaltyStampSuccess
  },
  props: {
    stampCollected: {
      type: Number,
      default: 0
    },
    rewardsPosition: {
      type: Array,
      default: () => ([])
    },
    successIconPaddingVertical: {
      type: String,
      default: '3px'
    },
    giftIconPaddingVertical: {
      type: String,
      default: '1px'
    },
    numberIconPaddingVertical: {
      type: String,
      default: '5px'
    },
  },
  data() {
    return {
      totalStamp: 10
    }
  },
  methods: {
    isRewardIcon(position) {
      return this.rewardsPosition.includes(position)
    }
  },
}
</script>


<style scoped>

</style>